import { useEffect, useState } from 'react'

export const useMediaQuery = (query: string): boolean => {
	const [matches, setMatches] = useState(false)

	useEffect(() => {
		const mediaQueryList = window.matchMedia(query)

		setMatches(mediaQueryList.matches)

		const handleChange = (event: MediaQueryListEvent) => {
			setMatches(event.matches)
		}

		if ('addEventListener' in mediaQueryList) {
			mediaQueryList.addEventListener('change', handleChange)
		} else {
			//@ts-ignore
			mediaQueryList.addListener(handleChange)
		}

		return () => {
			if ('removeEventListener' in mediaQueryList) {
				mediaQueryList.removeEventListener('change', handleChange)
			} else {
				//@ts-ignore
				mediaQueryList.removeListener(handleChange)
			}
		}
	}, [query])

	return matches
}
